(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dos-blog"]) return;
  try {
    
document.addEventListener('submit',function(event){
  if(event.target.id!=='dos-comment-form')return;
  const name=event.target.querySelector('[name="comment[author]"]');
  if(name&&!name.value.trim())name.value=name.dataset.guestName;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dos-hero"]) return;
  try {
    
document.querySelectorAll('[data-dos-hero]').forEach(function(root){
const track=root.querySelector('.dos-hero-track'),slides=Array.from(track.children),button=root.querySelector('[data-hero-pause]'),reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
let playing=!reducedMotion.matches,visible=false,index=0,activeIndex=-1,timer,swipeStart;
function move(delta){index=(index+delta+slides.length)%slides.length;sync()}
function sync(){clearTimeout(timer);const changed=index!==activeIndex;activeIndex=index;
slides.forEach(function(slide,i){const active=i===index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));const v=slide.querySelector('video');if(!v)return;v.muted=true;if(active&&changed)v.currentTime=0;if(!active||!playing||!visible||document.hidden){v.pause()}else{v.play().catch(function(){})}});
button.textContent=playing?button.dataset.pause:button.dataset.play;
if(playing&&visible&&!document.hidden&&!slides[index].querySelector('video'))timer=setTimeout(()=>move(1),8000)}
slides.forEach(function(s,i){const v=s.querySelector('video');if(v)v.addEventListener('ended',()=>{if(i===index&&playing&&visible&&!document.hidden)move(1)})});
button.onclick=function(){playing=!playing;sync()};root.querySelector('[data-hero-next]').onclick=()=>move(1);root.querySelector('[data-hero-prev]').onclick=()=>move(-1);
track.addEventListener('pointerdown',function(event){if(event.pointerType!=='touch'||event.target.closest('a,button'))return;swipeStart={id:event.pointerId,x:event.clientX,y:event.clientY}});
track.addEventListener('pointerup',function(event){if(!swipeStart||swipeStart.id!==event.pointerId)return;const dx=event.clientX-swipeStart.x,dy=event.clientY-swipeStart.y;swipeStart=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)move(dx<0?1:-1)});
track.addEventListener('pointercancel',function(){swipeStart=null});
document.addEventListener('visibilitychange',sync);window.addEventListener('resize',sync);
reducedMotion.addEventListener('change',function(){if(reducedMotion.matches)playing=false;sync()});
sync();track.classList.add('dos-hero-track--fade');
new IntersectionObserver(function(entries){visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.25;sync()},{threshold:.25}).observe(root);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dos-long-guide"]) return;
  try {
    
document.addEventListener('click',function(event){const a=event.target.closest('.dos-guide-index a');if(!a||event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;const target=document.getElementById(a.hash.slice(1));if(!target)return;event.preventDefault();event.stopImmediatePropagation();const header=document.querySelector('#shopify-section-header');window.scrollTo({top:window.scrollY+target.getBoundingClientRect().top-(header?header.offsetHeight:120)-24,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});history.replaceState(null,'',a.hash)},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dos-private"]) return;
  try {
    
document.addEventListener('click',function(event){
  const link=event.target.closest('.dos-private-index a[href^="#"]');
  if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const section=document.getElementById(link.getAttribute('href').slice(1));
  const heading=section&&section.querySelector('h2');
  if(!heading)return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const header=document.querySelector('#shopify-section-header');
  const offset=header?header.getBoundingClientRect().height:0;
  const top=Math.max(0,window.scrollY+heading.getBoundingClientRect().top-offset-24);
  heading.setAttribute('tabindex','-1');
  heading.focus({preventScroll:true});
  window.scrollTo({top:top,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  history.replaceState(null,'',link.getAttribute('href'));
},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click',function(event){document.querySelectorAll('.dos-nav-dropdown[open],.dos-bar-mobile[open]').forEach(function(menu){if(!(menu.closest('.dos-nav-group')||menu).contains(event.target))menu.removeAttribute('open')})});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.dos-nav-dropdown[open],.dos-bar-mobile[open]').forEach(function(menu){menu.removeAttribute('open');menu.querySelector('summary').focus()})}});
const dosNavHoverTimers = new WeakMap();
document.addEventListener('pointerover', function(event) {
  if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const group = event.target.closest('.dos-bar-desktop .dos-nav-group');
  if (!group || (event.relatedTarget instanceof Node && group.contains(event.relatedTarget))) return;
  const menu = group.querySelector('.dos-nav-dropdown');
  if (!menu) return;
  clearTimeout(dosNavHoverTimers.get(group));
  group.closest('nav').querySelectorAll('.dos-nav-dropdown[open]').forEach(function(other) {
    if (other !== menu) other.open = false;
  });
  menu.open = true;
});
document.addEventListener('pointerout', function(event) {
  if (event.pointerType !== 'mouse') return;
  const group = event.target.closest('.dos-bar-desktop .dos-nav-group');
  if (!group || (event.relatedTarget instanceof Node && group.contains(event.relatedTarget))) return;
  clearTimeout(dosNavHoverTimers.get(group));
  dosNavHoverTimers.set(group, setTimeout(function() {
    const menu = group.querySelector('.dos-nav-dropdown');
    if (menu && !group.matches(':hover') && !group.contains(document.activeElement)) menu.open = false;
  }, 180));
});

  } catch(e) { console.error(e); }
})();
})();
